import { render, staticRenderFns } from "./iconfont.vue?vue&type=template&id=dd446750&scoped=true"
import script from "./iconfont.vue?vue&type=script&lang=js"
export * from "./iconfont.vue?vue&type=script&lang=js"
import style0 from "./iconfont.vue?vue&type=style&index=0&id=dd446750&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd446750",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins_home/workspace/joinmc-html-develop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd446750')) {
      api.createRecord('dd446750', component.options)
    } else {
      api.reload('dd446750', component.options)
    }
    module.hot.accept("./iconfont.vue?vue&type=template&id=dd446750&scoped=true", function () {
      api.rerender('dd446750', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/iconfont.vue"
export default component.exports